// extracted by mini-css-extract-plugin
export var infoItem = "_rl-2";
export var title = "_rl-0";
export var value = "_rl-1";